import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setTodaysDate } from '../redux/modules/registration';
import formatDate from '../modules/formatDate';

class Today extends Component {
  constructor(props) {
    super(props);
    this.onSubmitDate = this.onSubmitDate.bind(this);
    this.setDate = this.setDate.bind(this);
    this.state = {
      date: null,
    };
  }

  setDate(e) {
    console.log('setting data to: ', e.target.value);
    this.setState({ date: e.target.value });
  }

  onSubmitDate(e) {
    console.log('submitting date to ', this.state.date);
    this.props.setTodaysDate(this.state.date);
    e.preventDefault();
  }

  render() {
    return (
      <div className="Box">
        <input
          className="u-hidden"
          type="text"
          id="TodaysDate"
          value={this.state.date || this.props.todaysDate}
          onChange={e => this.setDate(e)}
          tabIndex="-1"
        />
        <button tabIndex="-1" className="u-hidden" id="submitDate" onClick={e => this.onSubmitDate(e)}>submit</button>
        <span id="FormattedDate" className="FormattedDate">{formatDate(this.props.todaysDate)}</span>
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return { todaysDate: state.registration.today };
};

export default connect(mapStateToProps, { setTodaysDate })(Today);



// WEBPACK FOOTER //
// ./src/containers/Today.js